import React, { useEffect, useState } from "react";
import apiClient from "../../api/client";
import DashboardCard from "../shared/DashboardCard";
import { UserRoundCheck, Warehouse, UserRoundX, MapPinX } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL;

const configCards = [
  {
    key: 'asignados',
    titulo: 'Asignados',
    descripcion: 'Tags asignados y actualmente en operación',
    bg: 'bg-success',
    icon: <UserRoundCheck className="h-8 w-8 text-red-500" />
  },
  {
    key: 'stock',
    titulo: 'Stock',
    descripcion: 'Tags en stock listos para asignar',
    bg: 'bg-info',
    icon: <Warehouse className="h-8 w-8 text-yellow-500" />
  },
  {
    key: 'inactivos',
    titulo: 'Inactivos',
    descripcion: 'Tags asignados a personal fuera de operación',
    bg: 'bg-secondary',
    icon: <UserRoundX className="h-8 w-8 text-green-500" />
  },
  {
    key: 'extravios',
    titulo: 'Extravíos',
    descripcion: 'Tags extraviados reportados',
    bg: 'bg-danger',
    icon: <MapPinX className="h-8 w-8 text-blue-500" />
  }
];

function StatsTags() {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await apiClient.get(`/api/tags/stats`);
        setStats(res.data || {});
        const resTotal = await apiClient.get(`/api/tags/TotalStatsTags`);
        setTotal((resTotal.data[0].Total) || {});


      } catch (error) {
        console.error("Error al obtener estadísticas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "12vh" }}>
        <div className="spinner-border text-primary" role="status" style={{ width: "4rem", height: "4rem" }}>
          <span className="visually-hidden">.</span>
        </div>
      </div>
    );
  }

  // Add a safety check in case the API falls over or stats[0] is undefined
  if (!stats || !stats[0]) {
    return (
      <div className="alert alert-warning text-center mt-3" role="alert">
        No se pudieron cargar las estadísticas. Verifica la conexión.
      </div>
    );
  }

  return (
    <div className="row mt-4 pt-4 justify-content-center">
      {configCards.map(({ key, titulo, descripcion, bg, icon }) => (

        <DashboardCard
          key={key}
          titulo={titulo}
          descripcion={descripcion}
          valor={icon || 0}
          valordefault={(key === 'stock') ? 'Sahagún: ' + stats[0]['stockS'] + ' | Monterrey: ' + stats[0]['stockM'] : stats[0][key]}
          bg={bg}
          ruta={null}
          grande={false}
          bateriaSuperior={(key === 'stock') ?
            <>
              <span className="text-success font-weight-bold" style={{ fontSize: '1.2rem' }}>
                {stats[0]['stockS'] + stats[0]['stockM'] + ' | '}
              </span>
              {(100 * (stats[0]['stockS'] + stats[0]['stockM']) / total).toFixed(1) + '%'}
            </>
            : (100 * stats[0][key] / total).toFixed(1) + '%'}
        />
      ))}
    </div>
  );
}

export default StatsTags;
